/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import { Dropdown, Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  nameLabel,
  corporationNameLabel,
  addressLine1Label,
  addressLine2Label,
  addressLine3Label,
  cityLabel,
  stateLabel,
  zipLabel,
  zip4Label,
  phoneNumberLabel,
  extensionLabel,
  faxNumberLabel,
  emailLabel,
  manufacturersNameLabel,
  manufacturersIdLabel,
  clearNeedAttCode,
  sourceContactRemovedMsg,
  copiedSourceContact,
  noData,
  copiedNameDataSourceContact,
  copiedAddressDataSourceContact,
  noNeedsData,
  noRelData,
} from './ConstantData';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import {
  dispatchErrorMessageData,
  handleSuccessMessages,
} from '../store/Actions';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { getAllCommentCorrListForCommonPoc } from '../../../System/commentsAndCorrespondence/store/Actions';
import { EMAIL_ID_REGEX } from '../../../../SharedModules/AppConstants';

const Contact = (props) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openNoData, setOpenNoData] = useState(false);
  const [commonModalMsg, setCommonModalMsg] = useState('');
  const [showComments, setShowComments] = useState(false);
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [linkTableName, setLinkTableName] = useState('');
  const [commentIconVisable, setCommentIconVisable] = useState(false);
  const [commentIconVisableSource, setCommentIconVisableSource] =
    useState(false);
  const getCommentsService = () => {
    setShowComments(true);
  };
  const getErrorMsg = useSelector(
    (state) => state.sharedState.ContactAnomaliesReducer.errorMessageInRedux
  );
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
   const getContactAnomalies = useSelector(
      (state) => state.sharedState.ContactAnomaliesReducer.contactAnomaliesData
    );
  // comments functionality
  React.useEffect(() => {
    if (linkTableName === 'CONTACT' && showComments) {
      if (commentsList && commentsList.length > 0) {
        props.contactValues.ccCommentsExist = 1;
        setCommentIconVisable(true);
      } else {
        props.contactValues.ccCommentsExist = 0;
        setCommentIconVisable(false);
      }
    } else if (linkTableName === 'CONTACT_SOURCE' && showComments) {
      if (commentsList && commentsList.length > 0) {
        props.copyContactValues.ccCommentsExist = 1;
        setCommentIconVisableSource(true);
      } else {
        props.copyContactValues.ccCommentsExist = 0;
        setCommentIconVisableSource(false);
      }
    }
  }, [commentsList]);
  // Clear Needs Attention Code
  const clearNeedsValue = () => {
    if (props.contactValues && props.contactValues.length === 0) {
      setOpen(true);
      setCommonModalMsg(noNeedsData);
    } else {
      dispatch(handleSuccessMessages([]));
      props.setPageEdited(true);
      props.setDisableSaveCancel(true);
      props.setContactValues({
        ...props.contactValues,
        needsAttentionCd: null,
      });
      setOpen(true);
      setCommonModalMsg(clearNeedAttCode);
      props.setApiRefresh(true);
    }
  };
  // Remove Relationship to Source Contact
  const removeRelValue = () => {
    if (props.contactValues && props.contactValues.length === 0) {
      setOpen(true);
      setCommonModalMsg(noRelData);
    } else {
      dispatch(handleSuccessMessages([]));
      props.setPageEdited(true);
      props.setDisableSaveCancel(true);
      props.setContactValues({
        ...props.contactValues,
        copySourceSeqNum: null,
        addressChangedInd: 0,
        nameChangedInd: 0,
        needsAttentionCd: null,
      });
      setOpen(true);
      setCommonModalMsg(sourceContactRemovedMsg);
      props.setApiRefresh(true);
    }
  };
  // Recopy Source Contact
  const recopySourceContact = () => {
    dispatch(handleSuccessMessages([]));
    if (props.copyContactValues && props.copyContactValues.length != 0) {
      props.setPageEdited(true);
      props.setDisableSaveCancel(true);
      props.setContactValues({
        ...props.contactValues,
        contactName: props.copyContactValues.contactName,
        phoneNum: props.copyContactValues.phoneNum,
        phoneExtension: props.copyContactValues.phoneExtension,
        email: props.copyContactValues.email,
        corpName: props.copyContactValues.corpName,
        addrLine1: props.copyContactValues.addrLine1,
        addrLine2: props.copyContactValues.addrLine2,
        addrLine3: props.copyContactValues.addrLine3,
        city: props.copyContactValues.city,
        stateCd: props.copyContactValues.stateCd,
        zip: props.copyContactValues.zip,
        zip4: props.copyContactValues.zip4,
        faxNum: props.copyContactValues.faxNum,
        addressChangedInd: 0,
        nameChangedInd: 0,
        needsAttentionCd: null,
      });
      setOpen(true);
      setCommonModalMsg(copiedSourceContact);
      props.setApiRefresh(true);
    } else {
      setOpenNoData(true);
    }
  };
  // Copy Name Data From Source Contact
  const copyNameDataSourceContact = () => {
    dispatch(handleSuccessMessages([]));
    if (props.copyContactValues && props.copyContactValues.length != 0) {
      props.setPageEdited(true);
      props.setDisableSaveCancel(true);
      props.setContactValues({
        ...props.contactValues,
        contactName: props.copyContactValues.contactName,
        phoneNum: props.copyContactValues.phoneNum,
        phoneExtension: props.copyContactValues.phoneExtension,
        email: props.copyContactValues.email,
        addressChangedInd: 0,
        nameChangedInd: 0,
        needsAttentionCd: null,
      });
      setOpen(true);
      setCommonModalMsg(copiedNameDataSourceContact);
      props.setApiRefresh(true);
    } else {
      setOpenNoData(true);
    }
  };
  // Copy address Data From Source Contact
  const copyAddressDataSourceContact = () => {
    dispatch(handleSuccessMessages([]));
    if (props.copyContactValues && props.copyContactValues.length != 0) {
      props.setPageEdited(true);
      props.setDisableSaveCancel(true);
      props.setContactValues({
        ...props.contactValues,
        corpName: props.copyContactValues.corpName,
        addrLine1: props.copyContactValues.addrLine1,
        addrLine2: props.copyContactValues.addrLine2,
        addrLine3: props.copyContactValues.addrLine3,
        city: props.copyContactValues.city,
        stateCd: props.copyContactValues.stateCd,
        zip: props.copyContactValues.zip,
        zip4: props.copyContactValues.zip4,
        faxNum: props.copyContactValues.faxNum,
        addressChangedInd: 0,
        needsAttentionCd: null,
      });
      setOpen(true);
      setCommonModalMsg(copiedAddressDataSourceContact);
      props.setApiRefresh(true);
    } else {
      setOpenNoData(true);
    }
  };
  // fetch comments list for left grid
  const fetchCommentListForLeftGrid = async () => {
    dispatch(getAllCommentCorrListForCommonPoc(null));
    const result = await dispatch(
      getAllCommentCorrListForCommonPoc({
        corrLinkId: props.contactValues?.corrLinkId,
        linkTableName: 'CONTACT',
      })
    );
    if (result && result.CommentListData.length > 0) {
      props.contactValues.ccCommentsExist = 1;
      setCommentIconVisable(true);
    } else {
      props.contactValues.ccCommentsExist = 0;
      setCommentIconVisable(false);
    }
  };
  // fetch comments list for right grid
  const fetchCommentListForRightGrid = async () => {
    dispatch(getAllCommentCorrListForCommonPoc(null));
    const result = await dispatch(
      getAllCommentCorrListForCommonPoc({
        corrLinkId: props.copyContactValues?.corrLinkId,
        linkTableName: 'CONTACT',
      })
    );
    if (result && result.CommentListData.length > 0) {
      props.copyContactValues.ccCommentsExist = 1;
      setCommentIconVisableSource(true);
    } else {
      props.copyContactValues.ccCommentsExist = 0;
      setCommentIconVisableSource(false);
    }
  };
  // fetch left grid comment list based on contact values from contact anomalies parent component
  React.useEffect(() => {
    if (props.contactValues && props.contactValues?.corrLinkId) {
      fetchCommentListForLeftGrid();
    }
  }, [props.contactValues?.corrLinkId]);
  // fetch right grid comment list based on copy contact values from contact anomalies parent component
  React.useEffect(() => {
    if (props.copyContactValues && props.copyContactValues?.corrLinkId) {
      fetchCommentListForRightGrid();
    }
  }, [props.copyContactValues?.corrLinkId]);
  // handle events for contact tab fields
  const handleOnBlurEventContactTab = (value, name) => {
    let localErr = getErrorMsg || [];
    let showEmailErr = false;
    if (name === 'email' && value !== '' && !EMAIL_ID_REGEX.test(value)) {
      localErr = localErr?.filter((item) => item.fieldName !== name);
      localErr.push({
        fieldName: name,
        errorType: 'emailInvalid',
        tabName: 'Contact',
        message: constantMessageData.EMAIL_INVALID,
        subMessage: constantMessageData.EMAIL_INVALID,
      });
      showEmailErr = true;
      props.setDisableSaveCancel(false);
    }
    if (!showEmailErr) {
      localErr = localErr?.filter((item) => item.fieldName !== name);
    }
    dispatch(dispatchErrorMessageData([...new Set(localErr)]));
    dispatch(handleSuccessMessages([]));
  };
  // on change event on field
  const handleOnChangeEvent = (value, name) => {
    const regex = /^[0-9\b]+$/;
    if (name === 'faxNum') {
      if (value === '' || regex.test(value)) {
        props.setPageEdited(true);
        props.setDisableSaveCancel(true);
        props.setContactValues({
          ...props.contactValues,
          [name]: value,
        });
      }
    } else {
      props.setPageEdited(true);
      props.setDisableSaveCancel(true);
      props.setContactValues({
        ...props.contactValues,
        [name]: value,
      });
    }
    dispatch(handleSuccessMessages([]));
  };
  return (
    <div className="tBillPanel custom-check">
      <CommonModal
        open={open}
        data-testid="comman_modal1"
        viewAction
        viewHeader
        className="dialogPanel frr-rightAlignment custom-check dialog-420"
        onOk={() => setOpen(false)}
        okTitle="Ok"
        onClose={() => {
          setOpen(false);
        }}
        closeTitle="Cancel"
        modalTitle="Contact Anomalies"
        childrenComponent={
          <div>
            <p>{commonModalMsg}</p>
          </div>
        }
      />
      <CommonModal
        open={openNoData}
        data-testid="comman_modal2"
        viewAction
        viewHeader
        className="dialogPanel frr-rightAlignment custom-check dialog-420"
        onOk={() => setOpenNoData(false)}
        okTitle="Ok"
        onClose={() => {
          setOpenNoData(false);
        }}
        closeTitle="Cancel"
        modalTitle="Contact Anomalies"
        childrenComponent={
          <div>
            <p>{noData}</p>
          </div>
        }
      />
      <div className="btn-wrapper text-right mt-3">
        <Button
          className="btn btn-success btn-save mb-3"
          data-testid="need_code"
          onClick={() => clearNeedsValue()}
          disabled={!getContactAnomalies?.contactAnomaliesResponseVOs?.length}
        >
          Clear Needs Attention Code
        </Button>
        <Button
          className="btn btn-success btn-save mb-3"
          data-testid="remove_rel"
          onClick={() => removeRelValue()}
          disabled={!getContactAnomalies?.contactAnomaliesResponseVOs?.length}
        >
          Remove Relationship to Source Contact
        </Button>
        <Button
          className="btn btn-success btn-save mb-3"
          data-testid="re_copy_source"
          onClick={() => recopySourceContact()}
          disabled={!getContactAnomalies?.contactAnomaliesResponseVOs?.length}
        >
          Recopy Source Contact
        </Button>
        <Button
          className="btn btn-success btn-save mb-3"
          data-testid="copy_name_data"
          onClick={() => copyNameDataSourceContact()}
          disabled={!getContactAnomalies?.contactAnomaliesResponseVOs?.length}
        >
          Copy Name Data From Source Contact
        </Button>
        <Button
          className="btn btn-success btn-save mb-3"
          data-testid="copy_address_data"
          onClick={() => copyAddressDataSourceContact()}
          disabled={!getContactAnomalies?.contactAnomaliesResponseVOs?.length}
        >
          Copy Address Data From Source Contact
        </Button>
      </div>
      <Form>
        <div className="row">
          <div className="col-6">
            <div className="tab-body custom-check mt-3">
              <fieldset className="custom-fieldset w-100 customFormUi px-4">
                <legend>
                  {props.contactValues && props.contactValues.contactTypeCd
                    ? props.contactValues.contactTypeCd
                    : ''}
                </legend>
                <div className="row">
                  <div className="col-12 mui-custom-form mx-0 frr-fields-space">
                    <TextField
                      id="contact name mfginv"
                      label={nameLabel}
                      data-testid="name-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 50 }}
                      value={
                        props.contactValues && props.contactValues.contactName
                          ? props.contactValues.contactName
                          : ''
                      }
                    />
                    <TextField
                      id="corp name mfginv"
                      label={corporationNameLabel}
                      data-testid="Corporation-name-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 50 }}
                      value={
                        props.contactValues && props.contactValues.corpName
                          ? props.contactValues.corpName
                          : ''
                      }
                    />
                    <TextField
                      id="Address Lines1 Mfginv "
                      data-testid="Address-line1-mfginv"
                      label={addressLine1Label}
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 50 }}
                      value={
                        props.contactValues && props.contactValues.addrLine1
                          ? props.contactValues.addrLine1
                          : ''
                      }
                    />
                    <TextField
                      id="addrLine2mfg"
                      label={addressLine2Label}
                      data-testid="address-line2-mfg"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 50 }}
                      value={
                        props.contactValues && props.contactValues.addrLine2
                          ? props.contactValues.addrLine2
                          : ''
                      }
                    />
                    <TextField
                      id="addrLine3mfginv"
                      label={addressLine3Label}
                      data-testid="address-lines3-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 50 }}
                      value={
                        props.contactValues && props.contactValues.addrLine3
                          ? props.contactValues.addrLine3
                          : ''
                      }
                    />
                    <TextField
                      id="citymfginv"
                      label={cityLabel}
                      data-testid="city-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 30 }}
                      value={
                        props.contactValues && props.contactValues.city
                          ? props.contactValues.city
                          : ''
                      }
                    />
                    <TextField
                      id="statemfginv"
                      label={stateLabel}
                      data-testid="state-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 2 }}
                      value={
                        props.contactValues && props.contactValues.stateCd
                          ? props.contactValues.stateCd
                          : ''
                      }
                    />

                    <TextField
                      id="zipmfginv"
                      label={zipLabel}
                      data-testid="zip-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={
                        props.contactValues && props.contactValues.zip
                          ? props.contactValues.zip
                          : ''
                      }
                    />

                    <TextField
                      id="Zip4mfginv"
                      label={zip4Label}
                      data-testid="zip4-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 4 }}
                      value={
                        props.contactValues && props.contactValues.zip4
                          ? props.contactValues.zip4
                          : ''
                      }
                    />

                    <TextField
                      id="phoneNummfginv"
                      label={phoneNumberLabel}
                      data-testid="phone-mfginv"
                      className="mandate-fields"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={
                        props.contactValues && props.contactValues.phoneNum
                          ? props.contactValues.phoneNum
                          : ''
                      }
                    />

                    <TextField
                      id="Extensionmfginv"
                      label={extensionLabel}
                      data-testid="Extension-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 6 }}
                      value={
                        props.contactValues &&
                        props.contactValues.phoneExtension
                          ? props.contactValues.phoneExtension
                          : ''
                      }
                    />
                    <TextField
                      id="faxNummfginv"
                      label={faxNumberLabel}
                      data-testid="fax-mfginv"
                      fullWidth
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={
                        props.contactValues && props.contactValues.faxNum
                          ? props.contactValues.faxNum
                          : ''
                      }
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'faxNum')
                      }
                    />
                    <TextField
                      id="manufacturersName1"
                      label={manufacturersNameLabel}
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                        htmlFor: 'manufacturersName1',
                      }}
                      inputProps={{ maxLength: 120 }}
                      value={
                        props.contactValues && props.contactValues.mfgName
                          ? props.contactValues.mfgName
                          : ''
                      }
                    />
                    <TextField
                      id="manufacturersId1"
                      label={manufacturersIdLabel}
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                        htmlFor: 'manufacturersId1',
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={
                        props.contactValues && props.contactValues.key
                          ? props.contactValues.key
                          : ''
                      }
                    />
                    <TextField
                      id="emailAddrmfginv"
                      label={emailLabel}
                      className="mandate-fields"
                      data-testid="email-mfginv"
                      fullWidth
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 50 }}
                      value={
                        props.contactValues && props.contactValues.email
                          ? props.contactValues.email
                          : ''
                      }
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'email')
                      }
                      onBlur={(e) => {
                        handleOnBlurEventContactTab(e.target.value, 'email');
                      }}
                      helperText={
                        getErrorMsg?.length > 0
                          ? [
                              ...new Set(
                                getErrorMsg
                                  ?.filter((x) => {
                                    return (
                                      x.fieldName === 'email' &&
                                      x.tabName === 'Contact'
                                    );
                                  })
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        getErrorMsg?.length > 0 &&
                        getErrorMsg?.filter((x) => {
                          return (
                            x.fieldName === 'email' && x.tabName === 'Contact'
                          );
                        }).length > 0
                          ? [
                              ...new Set(
                                getErrorMsg
                                  ?.filter((x) => {
                                    return (
                                      x.fieldName === 'email' &&
                                      x.tabName === 'Contact'
                                    );
                                  })
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                    />
                  </div>
                </div>
                <div className="comment-sec mt-1">
                  Comments &nbsp;
                  {commentIconVisable ? (
                    <img
                      role="button"
                      onClick={() => {
                        getCommentsService();
                        setLinkTableName('CONTACT');
                        setCorrLinkId(
                          props.contactValues
                            ? props.contactValues?.corrLinkId
                            : ''
                        );
                      }}
                      alt="comment"
                      src={CommentVisibleIcon}
                    />
                  ) : (
                    <img
                      role="button"
                      data-testid="comment_icon"
                      onClick={() => {
                        getCommentsService();
                        setLinkTableName('CONTACT');
                        setCorrLinkId(
                          props.contactValues
                            ? props.contactValues?.corrLinkId
                            : ''
                        );
                      }}
                      alt="comment"
                      src={CommentIcon}
                    />
                  )}
                </div>
              </fieldset>
            </div>
          </div>
          {props.copyContactValues && props.copyContactValues.length != 0 ? (
            <div className="col-6">
              <div className="tab-body custom-check mt-3">
                <fieldset className="custom-fieldset w-100 customFormUi px-4">
                  <legend>Copy From Contact</legend>

                  <div className="row">
                    <div className="col-12 mui-custom-form mx-0 frr-fields-space ">
                      <TextField
                        id="contactnamecms"
                        label={nameLabel}
                        data-testid="name-cms"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 50 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.contactName
                        }
                      />
                      <TextField
                        id="corpName-cms"
                        label={corporationNameLabel}
                        data-testid="Corporation-name-cms"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 50 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.corpName
                        }
                      />
                      <TextField
                        id="Address Lines1 cms"
                        data-testid="Address-line1-cms"
                        label={addressLine1Label}
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 50 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.addrLine1
                            ? props.copyContactValues.addrLine1
                            : ''
                        }
                      />
                      <TextField
                        id="addrLine2cms"
                        label={addressLine2Label}
                        data-testid="address-line2-cms"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 50 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.addrLine2
                            ? props.copyContactValues.addrLine2
                            : ''
                        }
                      />
                      <TextField
                        id="addrLine3cms"
                        label={addressLine3Label}
                        data-testid="address-lines3-cms"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 50 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.addrLine3
                            ? props.copyContactValues.addrLine3
                            : ''
                        }
                      />
                      <TextField
                        id="citycms"
                        label={cityLabel}
                        data-testid="city-cms"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 30 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.city
                        }
                      />
                      <TextField
                        id="statecms"
                        label={stateLabel}
                        data-testid="state-cms"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 2 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.stateCd
                        }
                      />

                      <TextField
                        id="zipcmsinv"
                        label={zipLabel}
                        data-testid="zip-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={
                          props.copyContactValues && props.copyContactValues.zip
                        }
                      />

                      <TextField
                        id="Zip4cmsinv"
                        label={zip4Label}
                        data-testid="zip4-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 4 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.zip4
                        }
                      />

                      <TextField
                        id="phoneNumcmsinv"
                        label={phoneNumberLabel}
                        data-testid="phone-cmsinv"
                        className="mandate-fields"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.phoneNum
                        }
                      />

                      <TextField
                        id="Extensioncmsinv"
                        label={extensionLabel}
                        data-testid="Extension-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 6 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.phoneExtension
                        }
                      />

                      <TextField
                        id="faxNumcmsinv"
                        label={faxNumberLabel}
                        data-testid="fax-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.faxNum
                        }
                      />
                      <TextField
                        id="manufacturersName2"
                        label={manufacturersNameLabel}
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                          htmlFor: 'manufacturersName2',
                        }}
                        inputProps={{ maxLength: 120 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.mfgName
                        }
                      />
                      <TextField
                        id="manufacturersId2"
                        label={manufacturersIdLabel}
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                          htmlFor: 'manufacturersId2',
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={
                          props.copyContactValues && props.copyContactValues.key
                        }
                      />
                      <TextField
                        id="emailAddrcms"
                        label={emailLabel}
                        className="mandate-fields"
                        data-testid="email-cms"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 50 }}
                        value={
                          props.copyContactValues &&
                          props.copyContactValues.email
                        }
                      />
                    </div>
                  </div>
                  <div className="comment-sec mt-1">
                    Comments &nbsp;
                    {commentIconVisableSource ? (
                      <img
                        role="button"
                        onClick={() => {
                          getCommentsService();
                          setLinkTableName('CONTACT_SOURCE');
                          setCorrLinkId(
                            props.copyContactValues
                              ? props.copyContactValues?.corrLinkId
                              : ''
                          );
                        }}
                        alt="comment"
                        src={CommentVisibleIcon}
                      />
                    ) : (
                      <img
                        role="button"
                        data-testid="comment_icon2"
                        onClick={() => {
                          getCommentsService();
                          setLinkTableName('CONTACT_SOURCE');
                          setCorrLinkId(
                            props.copyContactValues
                              ? props.copyContactValues?.corrLinkId
                              : ''
                          );
                        }}
                        alt="comment"
                        src={CommentIcon}
                      />
                    )}
                  </div>
                </fieldset>
              </div>
            </div>
          ) : null}
        </div>
      </Form>
      <div className="btn-wrapper float-right mt-2">
        <Button
          className="btn btn-success btn-save"
          data-testid="open_Save"
          onClick={() => props.setSaveView(true)}
          disabled={!props.disableSaveCancel}
        >
          <SVGComponent iconName="Icon-awesome-save" />
          Save
        </Button>
        <Button
          className="btn btn-cancel"
          data-testid="open_Cancel"
          disabled={!props.disableSaveCancel}
          onClick={() => props.setCancelView(true)}
        >
          <SVGComponent iconName="Icon-cancel" />
          Cancel
        </Button>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CONTACT"
          corrLinkId={corrLinkId}
        />
      ) : null}
    </div>
  );
};
export default Contact;
